import React, { useEffect, useState } from "react";
import "../styles/CategoryModal.css"; // 必要に応じてこのCSSを調整

const CategoryModal = ({ isOpen, onSave, onCancel, categories }) => {
  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  // モーダルが開かれたときに初期化
  useEffect(() => {
    if (isOpen) setSelectedCategoryId("");
  }, [isOpen]);

  // Enterキーで保存、Escキーでキャンセル対応
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === "Enter" && selectedCategoryId) {
        onSave(Number(selectedCategoryId));
      }
      if (e.key === "Escape") {
        onCancel();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, selectedCategoryId, onSave, onCancel]);

  if (!isOpen) return null;

  return (
    <div className="CategoryModal-overlay">
      <div className="CategoryModal-content">
        <h3 className="CategoryModal-title">カテゴリーを選択してください</h3>
        <select
          className="CategoryModal-select"
          value={selectedCategoryId}
          onChange={(e) => setSelectedCategoryId(e.target.value)}
        >
          <option value="">-- カテゴリーを選択 --</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.category_name}
            </option>
          ))}
        </select>
        <div className="CategoryModal-buttons">
          <button
            className="CategoryModal-save"
            onClick={() => onSave(Number(selectedCategoryId))}
            disabled={!selectedCategoryId}
          >
            保存
          </button>
          <button className="CategoryModal-cancel" onClick={onCancel}>
            キャンセル
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoryModal;
